import React from "react";
import { Parah, PointsIcon, PointsWrapper, SubTitle } from "../ContentsStyles";

const PP_1 = () => {
  return (
    <Parah>
      <Parah>
        We collect your information in three ways: Information You Provide,
        Automatically Collected Information, and Information From Other Sources.
        More detail is provided below.
      </Parah>
      <SubTitle>Information You Provide</SubTitle>
      <PointsWrapper>
        <PointsIcon /> Profile Information
      </PointsWrapper>
      <Parah>
        We collect information that you provide when you set up an account, such
        as your date of birth, username, email address and/or telephone number,
        and password. You can add other information to your profile, such as a
        bio or a profile photo.
      </Parah>
      <PointsWrapper>
        <PointsIcon /> User Content
      </PointsWrapper>
      <Parah>
        We collect the content you create or publish through the Platform, such
        as photographs, videos, audio recordings, livestreams, and comments, and
        the associated metadata (such as when, where, and by whom the content
        was created). Even if you are not a user, information about you may
        appear in content created or published by users on the Platform. We
        collect User Content through pre-loading at the time of creation,
        import, or upload, regardless of whether you choose to save or upload
        that User Content, for example, to recommend music based on the video.
        We also collect content (such as text, images, and video) from your
        device's clipboard if you choose to copy and paste content to or from
        the Platform or share content between it and a third-party platform. In
        addition, we collect location information (such as tourist attractions,
        shops, or other points of interest) if you choose to add the location
        information to your User Content.
      </Parah>
      <PointsWrapper>
        <PointsIcon /> Direct Messages
      </PointsWrapper>
      <Parah>
        If you communicate with others using direct messages, we collect the
        content of the message and the associated metadata (such as the time the
        message was sent, received and/or read, as well as the participants in
        the communication). We do this to block spam, detect crime, and to
        safeguard our users.
      </Parah>
      <PointsWrapper>
        <PointsIcon /> Your Contacts
      </PointsWrapper>
      <Parah>
        If you choose to import your contacts, we will collect information from
        your device’s phone book or your social media contacts. We use this
        information to help you make connections, including when you are using
        our “Find Friends” function and to suggest accounts to you.
      </Parah>

      <PointsWrapper>
        <PointsIcon /> Purchase Information
      </PointsWrapper>
      <Parah>
        We collect your payment card information or other third-party payment
        information (such as PayPal) where payment is required. We also collect
        your transaction and purchase history.
      </Parah>

      <PointsWrapper>
        <PointsIcon /> Surveys, Research, and Promotions
      </PointsWrapper>
      <Parah>
        We collect information you provide if you choose to participate in a
        survey, research, promotion, contest, marketing campaign, or event
        conducted or sponsored by us.
      </Parah>

      <PointsWrapper>
        <PointsIcon /> Information When You Contact Us
      </PointsWrapper>
      <Parah>
        When you contact us, we collect the information you send us, such as
        proof of identity or age, feedback or inquiries about your use of the
        Platform or information about possible violations of our Terms of
        Service (our “Terms”), Community Guidelines (our “Guidelines”), or other
        policies.
      </Parah>

      <SubTitle>Automatically Collected Information</SubTitle>
      <PointsWrapper>
        <PointsIcon /> Technical Information
      </PointsWrapper>
      <Parah>
        We collect certain device and network connection information when you
        access the Platform. This information includes your device model,
        operating system, keystroke patterns or rhythms, IP address, and system
        language. We also collect service-related, diagnostic, and performance
        information, including crash reports and performance logs. We
        automatically assign you a device ID and user ID. Where you log-in from
        multiple devices, we use information such as your device ID and user ID
        to identify your activity across devices to give you a seamless log-in
        experience and for security purposes.
      </Parah>
      <PointsWrapper>
        <PointsIcon /> Location Information
      </PointsWrapper>
      <Parah>
        We automatically collect information about your approximate location
        (e.g. country, state, or city) based on your Technical Information (such
        as SIM card and IP address). Also, where you enable Location Services
        for the Talents Explore app within your device settings, we collect
        approximate location information from your device.
      </Parah>
      <PointsWrapper>
        <PointsIcon /> Usage Information
      </PointsWrapper>
      <Parah>
        We collect information about how you engage with the Platform, including
        information about the content you view, the duration and frequency of
        your use, your engagement with other users, your search history, and
        your settings.
      </Parah>
      <PointsWrapper>
        <PointsIcon /> Content Characteristics and Features
      </PointsWrapper>
      <Parah>
        We detect and collect characteristics and features about the videos,
        images, and audio recordings that are part of your User Content, for
        example, by identifying objects and scenery, the existence or location
        within an image of a face or other body parts; and the text of words
        spoken in your User Content. We do this, for example, for content
        moderation.
      </Parah>
      <PointsWrapper>
        <PointsIcon /> Inferred Information
      </PointsWrapper>
      <Parah>
        We infer your attributes (such as age-range and gender) and interests
        based on the information we have about you. We use inferences, for
        example, to keep the Platform safe, for content moderation and, where
        permitted, to serve you personalised ads based on your interests.
      </Parah>
      <PointsWrapper>
        <PointsIcon /> Cookies
      </PointsWrapper>
      <Parah>
        We use cookies and similar tracking technologies to operate and provide
        the Platform. For example, we use cookies to remember your language
        preferences, make sure you don’t see the same video more than once, and
        for security purposes. We also use these technologies for marketing
        purposes. To learn more about our use of cookies, please see our Web
        Cookies Policy and Platform Cookies Policy. We will obtain your consent
        to our use of cookies where required by law.
      </Parah>
      <SubTitle>Information From Other Sources</SubTitle>
      <PointsWrapper>
        <PointsIcon /> Advertising, Measurement and Data Partners
      </PointsWrapper>
      <Parah>
        Advertisers, measurement, and data partners share information with us
        such as mobile identifiers for advertising, hashed email addresses, and
        event information about the actions you’ve taken outside of the
        Platform. Some of our advertisers and other partners enable us to
        collect similar information directly from their website.
      </Parah>
      <PointsWrapper>
        <PointsIcon /> Third Party Platforms and Partners
      </PointsWrapper>
      <Parah>
        Third party platforms provide us with information (such as your email
        address, user ID, and public profile) when you choose to sign up for or
        log in to the Platform using sign-in features provided by those third
        parties. We may also receive contact information that you hold or is
        held about you when contact information is synced with our Platform by
        you or another user. When you interact with any third party service
        (such as third party apps, websites or products) that integrate Talents
        Explore Developer Tools, we will receive the information necessary to
        provide you with features like cross-service authentication or
        cross-posting. For example, this will happen if you log in to another
        platform with your Talents Explore account or if you use Talents
        Explore’s “share” button on a third-party platform to share content from
        there to the Platform.
      </Parah>
      <PointsWrapper>
        <PointsIcon /> Others
      </PointsWrapper>
      <Parah>
        We may receive information about you from others, for example, where you
        are included or mentioned in User Content, Direct Messages, in a
        complaint, appeal, request or feedback submitted by a user or third
        party, or if your contact information is provided to us by a user.
      </Parah>
    </Parah>
  );
};

export default PP_1;
